import React, { useState, useRef, useEffect } from "react";
import "./TimePicker.scss";
import { TimePicker } from "antd";

/* this component uses datejs library to format time */
const Time = ({ title, modificator = "default", onChange = null, initialTime = null }) => {
  const format = "HH:mm";
  const timePicker = useRef(null);

  let mobile = window.matchMedia("(max-width: 640px)");

  const [value, setValue] = useState(null);


  return (
    <div ref={timePicker} className={`timepicker ${modificator}`} >
      <h3 className="timepicker__title">Godzina odbioru</h3>
      <TimePicker
        minuteStep={15}
        hourStep={1}
        placeholder="Podaj godzinę"
        format={format}
        showNow={false}
        inputReadOnly={true}
        getPopupContainer={(triggerNode) => {
          return triggerNode.parentNode;
        }}
        renderExtraFooter={() => (
          <div className="timepicker__header">
            <p className="timepicker__heading">Godziny</p>
            <p className="timepicker__heading">Minuty</p>
          </div>
        )}
      />
    </div>
  );
};

export default Time;
